import type { DatasetDeleteOptions } from "./dataset-delete.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

import { getDatasetInvalidate } from "../dataset-invalidate";

export const useDatasetDelete = (
  datasetId: number,
  options: DatasetDeleteOptions = {}
) => {
  const onSuccess = useMutationOnSuccess({
    onSuccess: options.onSuccess,
    onSuccessAwaited: options.onSuccessAwaited,
    invalidate: getDatasetInvalidate(datasetId, options.invalidate),
  });

  const { mutate, status, isPending } = useMutation<ApiEmptyResponse, ApiError>(
    {
      mutationKey: ["datasets", "delete", datasetId],
      mutationFn: () => client.datasets.destroy(datasetId),
      onSuccess,
    }
  );

  return {
    deleteDataset: mutate,
    status,
    isPending,
  };
};
